import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  InputNumber,
  message,
  Row,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "./WizardConfig.css";

import { postConsentConfig } from "../../api/requests";
import { logout, setAppSettings } from "../../reducers/user/actions";

class ConsentConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      consentConfigData: {},
      isLoadingData: false,
      isLoading: false,
      drugDosageSettingsKeys: [],
      drugDosageSettingsValues: {},
      randomizationData: null,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.consentConfigData.is_configured !==
      this.props.consentConfigData.is_configured
    ) {
      this.setData();
    }
  }

  setData = () => {
    this.setState({
      consentConfigData: this.props.consentConfigData,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      errorMessage: null,
    });
    this.props.form.validateFields(async (err, values) => {
      const data = { ...values };

      this.props.form.setFields({
        pre_randomization_consent: {
          value: values.pre_randomization_consent,
          errors: null,
        },
        pre_randomization_email_consent: {
          value: values.pre_randomization_email_consent,
          errors: null,
        },
        allow_recording_consent_by_user_id: {
          value: values.allow_recording_consent_by_user_id,
          errors: null,
        },
        password_required: { value: values.password_required, errors: null },
        limit_consent_to_subject_site: {
          value: values.limit_consent_to_subject_site,
          errors: null,
        },
      });

      try {
        await postConsentConfig(data);
        message.success(this.props.i18n.t("Saved"));
        this.props.setAppSettings();
        this.props.onSubmit();
      } catch (e) {
        if (get(e, "response.data.errors")) {
          const errors = {};
          Object.keys(get(e, "response.data.errors")).forEach(
            (errorFieldKey) => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                  (errorMessage) => new Error(errorMessage)
                ),
              };
            }
          );
          this.props.form.setFields(errors);
        } else {
          this.setState({
            errorMessage: JSON.stringify(get(e, "response.data.errors")),
          });
        }
        message.error(this.props.i18n.t("Error"));
        console.log(e);
      }
    });
  };

  render() {
    const {
      consentConfigData,
      isLoading,
      isLoadingData,
      errorMessage,
    } = this.state;
    const { randomizationData, isDisabled } = this.props;
    const { getFieldDecorator } = this.props.form;
    const isRandomizeConfig =
      get(randomizationData, "treatment_groups", []).length > 0;
    const isEditable = isRandomizeConfig;

    return (
      <div className={classes.formWrapper}>
        <h3 className="headline-default">{this.props.i18n.t("NamespaceWizardConfig:Consent Config")}</h3>

        {!isLoadingData ? (
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={8}>
              <Col sm={24}>
                {!isRandomizeConfig && (
                  <Alert
                    type="warning"
                    message={this.props.i18n.t(
                      "NamespaceWizardConfig:Please fill Randomization Config first"
                    )}
                  />
                )}
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("pre_randomization_consent", {
                      initialValue: get(
                        consentConfigData,
                        "pre_randomization_consent",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t("NamespaceWizardConfig:Pre randomization consent")}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("pre_randomization_email_consent", {
                      initialValue: get(
                        consentConfigData,
                        "pre_randomization_email_consent",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t("NamespaceWizardConfig:Allow pre randomization consent via email")}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("allow_recording_consent_by_user_id", {
                      initialValue: get(
                        consentConfigData,
                        "allow_recording_consent_by_user_id",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t(
                            "NamespaceWizardConfig:Allow recording consent by user id"
                          )}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("password_required", {
                      initialValue: get(
                        consentConfigData,
                        "password_required",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t("NamespaceWizardConfig:Require password")}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("limit_consent_to_subject_site", {
                      initialValue: get(
                        consentConfigData,
                        "limit_consent_to_subject_site",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t("NamespaceWizardConfig:Limit consent to subject site")}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <b>{this.props.i18n.t("NamespaceWizardConfig:Consent email expiration hours")}</b>
                <div style={{ margin: "0 0 30px", width: "250px" }}>
                  {getFieldDecorator("consent_email_expiration_hours", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      consentConfigData,
                      "consent_email_expiration_hours"
                    ),
                  })(<InputNumber disabled={!isEditable || isDisabled} />)}
                </div>
              </Col>
            </Row>

            <br />
            <Row gutter={8}>
              {errorMessage && (
                <Col span={24}>
                  <Alert message={errorMessage} type="error" />
                </Col>
              )}
              <Col span={24}>
                <Button
                  disabled={!isEditable || isDisabled}
                  type="primary"
                  size="large"
                  htmlType="submit"
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Icon type="loading" />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAppSettings, logout };

export default Form.create({ name: "ConsentConfigForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ConsentConfigForm))
);



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/ConsentConfigForm.js